import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

/**
 * Not applying to avatar at the moment as we need to consider badges.
 */
@Directive({
  selector: 'ion-icon,ion-img,hr',
  standalone: true,
})
export class AriaHiddenDirective implements AfterViewInit {
  constructor(
    private element: ElementRef,
    private renderer: Renderer2,
  ) {}

  // The directive adds aria-hidden to listed elements (directive selector) except for buttons with icon-only slot and aria-hidden="false"
  ngAfterViewInit() {
    // Exclude buttons icon buttons.
    const ele = this.element.nativeElement;
    const ariaHidden = ele.getAttribute('aria-hidden');
    if (
      !(ele.nodeName === 'ION-ICON' && ele.slot === 'icon-only') &&
      // TODO: cleanup
      // Check for icon-only buttons. Will be removed after UI uplift
      !(ele.parentElement && ele.parentElement.nodeName === 'ION-BUTTON' && ele.parentElement.slot === 'icon-only') &&
      ariaHidden !== 'false'
    ) {
      this.renderer.setAttribute(this.element.nativeElement, 'aria-hidden', 'true');
    }
  }
}
